// extracted by mini-css-extract-plugin
module.exports = {"row":"CollectionProductsList_row__2t__x","col":"CollectionProductsList_col__3VbxV","card":"CollectionProductsList_card__tafqZ"};